// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AreasUI_view__qUQEA {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}

.AreasUI_buttons__WSGzu {
  display: flex;
  gap: 10px;
  align-items: center;
}

.AreasUI_loader__dE70X {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
}

.AreasUI_actions__h66Gs {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.AreasUI_edit__CS5TZ,
.AreasUI_delete__Vh4L1 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.AreasUI_edit__CS5TZ:hover {
  transform: translateY(-1px);
}

.AreasUI_delete__Vh4L1:hover {
  transform: translateY(-1px);
}

.AreasUI_divider__iSO9N {
  width: 1px;
  height: 20px;
  background-color: #d9d9d9;
}

.AreasUI_branchesList__gHCkm {
  text-align: left;
  max-width: 180px;
}

.AreasUI_branchItem__PSF\\+0 {
  margin-bottom: 4px;
  padding: 2px 4px;
  background-color: #f0f0f0;
  border-radius: 4px;
  font-size: 12px;
  color: #333;
}

.AreasUI_moreBranches__3m24l {
  color: #1890ff;
  font-size: 11px;
  font-style: italic;
  margin-top: 4px;
}

.AreasUI_noBranches__MWuaS {
  color: #999;
  font-style: italic;
  font-size: 12px;
}

/* Responsive */

@media (max-width: 768px) {
  .AreasUI_view__qUQEA {
    padding: 10px;
  }

  .AreasUI_buttons__WSGzu {
    flex-direction: column;
    gap: 8px;
  }

  .AreasUI_actions__h66Gs {
    flex-direction: column;
    gap: 4px;
  }

  .AreasUI_divider__iSO9N {
    width: 20px;
    height: 1px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/areas/styles/AreasUI.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA,eAAe;;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,WAAW;EACb;AACF","sourcesContent":[".view {\n  padding: 20px;\n  background-color: #f5f5f5;\n  min-height: 100vh;\n}\n\n.buttons {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 400px;\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.edit,\n.delete {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.edit:hover {\n  transform: translateY(-1px);\n}\n\n.delete:hover {\n  transform: translateY(-1px);\n}\n\n.divider {\n  width: 1px;\n  height: 20px;\n  background-color: #d9d9d9;\n}\n\n.branchesList {\n  text-align: left;\n  max-width: 180px;\n}\n\n.branchItem {\n  margin-bottom: 4px;\n  padding: 2px 4px;\n  background-color: #f0f0f0;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #333;\n}\n\n.moreBranches {\n  color: #1890ff;\n  font-size: 11px;\n  font-style: italic;\n  margin-top: 4px;\n}\n\n.noBranches {\n  color: #999;\n  font-style: italic;\n  font-size: 12px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .view {\n    padding: 10px;\n  }\n  \n  .buttons {\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .actions {\n    flex-direction: column;\n    gap: 4px;\n  }\n  \n  .divider {\n    width: 20px;\n    height: 1px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"view": `AreasUI_view__qUQEA`,
	"buttons": `AreasUI_buttons__WSGzu`,
	"loader": `AreasUI_loader__dE70X`,
	"actions": `AreasUI_actions__h66Gs`,
	"edit": `AreasUI_edit__CS5TZ`,
	"delete": `AreasUI_delete__Vh4L1`,
	"divider": `AreasUI_divider__iSO9N`,
	"branchesList": `AreasUI_branchesList__gHCkm`,
	"branchItem": `AreasUI_branchItem__PSF+0`,
	"moreBranches": `AreasUI_moreBranches__3m24l`,
	"noBranches": `AreasUI_noBranches__MWuaS`
};
export default ___CSS_LOADER_EXPORT___;
